<template>
    <div class="m-completed-map" v-loading="loading" ref="container">
        <el-button class="u-phone-download" icon="el-icon-download" @click="exportToImage">下载</el-button>
        <div class="m-boss-list" ref="map">
            <div
                class="u-step"
                :class="currentBoss.dwBossID ? 'has-info' : ''"
                v-for="(item, stepIndex) in list"
                :key="stepIndex"
            >
                <div
                    class="u-floor"
                    :class="[
                        floor.nEffectID ? 'is-effect' : '',
                        floor.dwBossID === currentBoss.dwBossID ? 'is-info' : '',
                        getCurrentStyle(floor, stepIndex * $attrs.column + index + 1),
                    ]"
                    v-for="(floor, index) in item"
                    :key="index"
                    @click.prevent="setBossHandler(stepIndex * $attrs.column + index + 1)"
                >
                    <div class="u-floor-content">
                        <div class="u-index" :class="floor.nEffectID && 'u-effect'">
                            {{ stepIndex * $attrs.column + index + 1 }}
                        </div>
                        <div class="u-img">
                            <img :src="getBossAvatar(floor.dwBossID)" :alt="floor.bossName || '未知'" />
                        </div>
                        <div class="u-name" :class="currentBossName === floor.bossName && 'is-current'">
                            {{ floor.bossName }}
                        </div>
                        <div
                            v-if="
                                getEffectInfo(effects, floor.nEffectID, 'tags').length ||
                                getEffectInfo(effects, floor.nEffectID, 'reward')
                            "
                            class="u-desc"
                        >
                            <div v-if="getEffectInfo(effects, floor.nEffectID, 'tags').length" class="u-sketch">
                                <div
                                    class="u-sketch-info"
                                    v-for="(tag, si) in getEffectInfo(effects, floor.nEffectID, 'tags')"
                                    :key="si"
                                >
                                    {{ tag }}
                                </div>
                            </div>
                            <div v-if="getEffectInfo(effects, floor.nEffectID, 'reward')" class="u-coin">
                                <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'u-coin-img'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M6.762.694c.14-.022.28-.035.422-.039.03.04.037.09.052.135.044.16.1.317.148.476.047.14.08.283.13.422.044.125.083.251.118.379.065.198.13.397.188.598.051.16.103.321.152.483.05.178.116.352.166.53.141.45.266.905.415 1.353.073.228.149.456.22.685.051.155.103.31.148.468.054.179.116.355.166.534.061.196.13.39.185.59.108.318.197.643.304.962.08.284.18.562.262.845.057.169.106.34.162.51a.673.673 0 00-.027.057c-.083.008-.164.031-.247.045-.056-.002-.107.03-.163.029-.04-.003-.076.011-.113.023-.045.007-.09.004-.133.02-.035.012-.073.012-.11.012-.035-.002-.064.024-.1.022a.49.49 0 00-.156.027c-.038.013-.08.008-.118.022-.064.02-.134.02-.198.04-.048.016-.1.006-.146.025-.048.018-.1.01-.148.026a.608.608 0 01-.147.027c-.053.019-.106.04-.163.038a.375.375 0 01-.126.033c-.053.002-.1.037-.154.03-.07-.007-.135.023-.203.025-.207.044-.416.079-.623.124-.06 0-.116.029-.176.03-.062.002-.115.042-.178.036-.053-.005-.097.05-.151.03-.04-.013-.075.02-.114.02a.66.66 0 00-.17.035c-.086.002-.165.04-.25.043-.07.025-.143.02-.212.043-.045.01-.094.006-.135.031-.024.018-.055.012-.083.013-.052-.003-.1.024-.152.026-.072.003-.131.054-.203.05-.034-.004-.063.015-.093.024-.032.004-.064 0-.095.003-.033.012-.067.027-.103.023-.075-.005-.143.03-.216.037-.044.001-.082.033-.126.028-.045-.005-.086.012-.128.022-.067.005-.132.021-.196.037-.085.005-.165.038-.25.043a.414.414 0 01-.165.023.195.195 0 01-.03-.108.219.219 0 01-.025-.113c-.028-.046-.022-.1-.046-.148-.04-.135-.077-.271-.114-.407-.002-.05-.032-.093-.032-.143-.012-.052-.03-.101-.037-.154-.027-.044-.017-.1-.046-.143 0-.065-.045-.119-.044-.184-.028-.06-.025-.13-.055-.19-.005-.029.002-.06-.017-.085-.017-.023-.01-.052-.018-.077-.026-.055-.036-.116-.057-.173-.01-.063-.045-.118-.043-.182a.162.162 0 01-.024-.104c-.028-.05-.023-.108-.047-.159-.03-.09-.05-.183-.079-.274-.003-.05-.035-.092-.036-.141-.003-.04-.026-.074-.028-.112-.005-.053-.037-.098-.035-.15-.003-.032-.03-.057-.026-.09.003-.037-.028-.065-.027-.102-.003-.045-.033-.083-.036-.127-.004-.057-.046-.104-.04-.162-.036-.047-.013-.109-.045-.158-.006-.06-.033-.115-.046-.174-.024-.06-.031-.123-.058-.181a.19.19 0 00-.02-.084c-.014-.026-.004-.058-.016-.085-.022-.058-.025-.12-.047-.178l-.071-.246c-.005-.057-.038-.106-.04-.163-.025-.064-.03-.133-.057-.197-.004-.034-.006-.069-.023-.1a4.916 4.916 0 00-.086-.325c-.026-.046-.016-.1-.044-.145-.005-.034-.006-.07-.021-.101-.044-.19-.111-.372-.153-.562a9.574 9.574 0 00-.139-.504c-.018-.108-.06-.21-.078-.318-.048-.171-.09-.344-.143-.514-.05-.226-.12-.447-.18-.67-.062-.267-.147-.528-.209-.794-.04-.14-.07-.283-.116-.422a.268.268 0 00-.036-.11.795.795 0 01-.046 0c.002.052.034.096.038.147.039.124.075.249.105.376.013.033.02.068.024.104.01.029.022.058.024.089.063.2.118.402.165.607.056.207.12.411.166.62a.457.457 0 01.026.113.262.262 0 01.026.1c.03.047.03.104.05.153.024.095.055.188.074.284.049.188.106.375.157.563.058.267.146.528.207.794.014.027.015.057.016.086.012.03.025.059.026.09.08.226.127.462.193.692.05.18.103.359.146.54.032.155.086.305.123.458.02.042.014.09.035.132.013.03.004.065.018.095.021.044.02.094.042.136.015.025.007.056.02.08.025.046.027.098.045.145.047.174.087.35.139.522.05.177.098.354.14.533.04.156.09.31.126.467.02.044.018.095.037.14.012.027.007.057.018.084.025.039.016.088.04.127.04.136.078.272.11.41.066.257.148.509.205.767.024.044.019.093.022.14h-.062c-.074-.247-.136-.498-.202-.749-.086-.282-.141-.574-.243-.852.005-.057-.025-.108-.034-.163-.073-.285-.158-.566-.227-.85a25.537 25.537 0 01-.188-.7c-.079-.256-.14-.518-.213-.777-.054-.181-.097-.366-.148-.548-.038-.172-.096-.339-.137-.51-.036-.15-.08-.298-.123-.447a.459.459 0 00-.03-.094c-.066-.305-.165-.602-.236-.906-.042-.16-.087-.319-.132-.478-.072-.295-.164-.585-.236-.88-.08-.275-.15-.552-.222-.829-.066-.22-.121-.445-.182-.667a.456.456 0 00-.031-.092L.992 1.34a.143.143 0 00.01.09c.076.273.14.55.224.822.01.051.032.1.032.153-.117.011-.233.04-.351.04-.063.011-.125.03-.19.026-.074-.004-.144.03-.219.026-.036-.087-.05-.181-.077-.272-.066-.254-.138-.508-.205-.762 0-.03-.01-.06-.033-.08-.034-.007-.069.008-.1.02a.254.254 0 01.14-.125c.016.007.034.017.053.016.103 0 .206-.001.307-.023.067-.009.136 0 .202-.014.063.002.124-.026.187-.014.012.023.02.048.03.071L1 1.23c.073-.03.155-.004.232-.018.066-.016.135-.004.2-.02.109-.003.214-.028.323-.028.046.001.091-.013.138-.015.064-.017.132-.004.197-.02.113-.003.223-.03.336-.028.073-.001.144-.02.216-.025.174-.002.345-.038.52-.04.138-.03.282-.018.42-.048.072 0 .142-.017.213-.014.085-.008.168-.03.254-.026.143-.012.286-.037.43-.038.084-.013.168-.027.254-.025.085.001.167-.03.253-.027.077-.012.155-.004.23-.023.063-.013.126-.013.19-.014.084-.01.167-.027.252-.027.06-.016.122-.003.182-.019.053-.003.106-.018.16-.016.111.003.22-.03.33-.028.067-.015.137-.003.203-.02.076-.006.151-.019.228-.017zm-.397.554c-.112.017-.233-.018-.341.029-.08 0-.16.004-.238.02-.105.022-.211.016-.316.02-.126.036-.26-.014-.385.032-.094.01-.19-.004-.285.01-.042.011-.087.006-.13.015-.044.009-.094-.005-.134.021-.007.072.038.131.055.197.015.061.041.119.052.18.03.059.024.128.056.185 0 .046.005.09.027.13.002.065.042.12.042.185.011.027.034.049.035.08 0 .037.024.068.04.102.002.028-.002.056.001.084.01.016.022.031.033.047.006.03-.003.061.012.089a.46.46 0 01.032.123c.014.03.024.062.028.096.052.086.078.185.105.281.023.05.022.105.044.155.014.03.006.065.01.097.027.122.067.24.1.36.057.175.105.352.149.53.024.054.04.112.077.159.005.065.044.121.047.187.016.046.034.09.034.14a.42.42 0 01.036.129c.03.054.037.117.064.174.013.07.045.134.056.204a.251.251 0 01.022.12c.015.037.041.073.035.115-.01.042.032.071.026.113-.006.051.036.09.038.14.003.045.046.078.039.126.06.189.104.383.167.572.055.183.105.368.16.551.069.25.146.497.215.746.004.062.046.114.043.177a.704.704 0 00.142-.001c.087-.025.178-.03.264-.054.033-.01.068-.004.1-.014.028-.007.054-.019.082-.019.078-.002.15-.035.227-.037.048-.003.092-.028.14-.026.048.004.09-.026.138-.026.075-.002.144-.036.218-.038.044-.002.083-.025.127-.025.07-.005.136-.037.206-.037.051-.001.097-.03.149-.026.044.003.083-.023.127-.025.082 0 .158-.036.239-.039.04-.006.086-.02.106-.057.007-.052-.03-.092-.047-.138.003-.06-.036-.108-.04-.167.001-.027-.017-.048-.039-.062.002-.024 0-.048.003-.072l-.031-.013c.004-.032.006-.066-.015-.093-.03-.042-.018-.099-.047-.141-.022-.027-.004-.064-.023-.092-.028-.052-.035-.112-.064-.164-.028-.107-.073-.209-.09-.318a.205.205 0 01-.026-.104c-.03-.062-.038-.13-.07-.19-.002-.049-.04-.085-.044-.133-.004-.049-.042-.088-.038-.138 0-.04-.033-.072-.034-.113.004-.046-.031-.082-.03-.128.003-.035-.037-.053-.036-.088-.005-.042-.038-.073-.045-.114-.013-.059-.045-.111-.047-.172-.029-.057-.028-.123-.055-.18-.005-.036-.005-.072-.028-.101-.034-.105-.08-.207-.104-.315-.026-.064-.034-.133-.06-.196 0-.06-.036-.112-.041-.172-.023-.034-.03-.074-.04-.113-.03-.048-.033-.106-.057-.157-.016-.035-.015-.075-.031-.11-.02-.04-.013-.089-.038-.127-.017-.027-.008-.061-.023-.09-.025-.044-.026-.096-.05-.141-.047-.13-.078-.266-.125-.397-.002-.066-.056-.12-.04-.188.016.026.026.054.042.08-.038-.123-.069-.249-.114-.37l-.009.06a.383.383 0 01-.032-.097c-.028-.087-.06-.173-.079-.262-.024-.039-.025-.084-.04-.126-.023-.049-.023-.104-.05-.152-.007-.06-.044-.112-.055-.171-.006-.036-.034-.066-.03-.104a.15.15 0 00-.016-.073c-.019-.033-.003-.074-.024-.105a.142.142 0 01-.023-.102.132.132 0 01-.039-.152.116.116 0 00-.11-.027c-.091.027-.192-.01-.282.031zm.906 1.676c-.023.034.044.003 0 0zM4.564.822c.058-.004.116-.004.175-.002a.621.621 0 01-.175.002zM7.362.954c.059.08.073.18.11.27.03.069.045.143.067.215.04.156.087.311.13.467.01.049.034.096.024.147-.022-.103-.06-.202-.09-.304-.083-.244-.15-.493-.237-.736-.004-.02-.003-.04-.004-.059z" fill="#DEDDD3"/><path d="M6.306 1.29c.115.003.227-.032.342-.025.022 0 .042.011.055.028.016.072.043.14.055.213.022.043.016.094.04.136.021.039.018.086.045.122.053.151.091.307.133.461.027.04.017.092.048.13.075.214.13.434.2.65.057.176.112.355.163.533.024.049.02.106.048.153.022.107.068.207.097.312.028.052.031.113.057.166.006.058.038.108.043.166.046.146.093.292.145.436.008.06.04.112.045.172.027.081.047.165.068.247.038.081.067.166.088.253.023.046.024.1.045.146.014.033.009.07.024.103.014.032.019.066.027.1.018.026.03.056.037.087.045.11.076.224.11.338a.26.26 0 00.023.089c.028.135.087.261.127.394.009.047.03.091.038.139.006.041.03.078.034.12.006.044.034.083.034.128-.002.031.028.051.03.081.005.039.024.072.038.107.022.084.061.164.064.251-.049.026-.104.032-.158.04-.095.022-.193.033-.289.053-.07.004-.136.034-.207.034a.726.726 0 01-.148.03c-.096.024-.196.033-.292.058-.087.001-.169.04-.256.037-.047.013-.094.029-.143.024-.036-.003-.064.027-.1.026a.319.319 0 00-.1.015c-.063.022-.132.02-.197.04a.404.404 0 01-.16.012.201.201 0 01-.105-.213.331.331 0 01-.084-.112c-.06-.187-.109-.377-.16-.566-.042-.136-.085-.272-.12-.411-.026-.059-.03-.123-.056-.181a.422.422 0 00-.036-.122c.002-.065-.04-.119-.046-.182-.03-.064-.039-.134-.065-.199-.009-.058-.04-.11-.049-.169-.008-.037-.032-.07-.032-.109 0-.045-.033-.081-.036-.126-.001-.045-.03-.083-.036-.127-.007-.05-.033-.096-.042-.147-.04-.11-.066-.226-.104-.337-.004-.063-.038-.118-.04-.18a.429.429 0 01-.035-.13c-.03-.06-.038-.127-.067-.188-.012-.065-.047-.123-.051-.19-.03-.058-.027-.126-.054-.186 0-.058-.035-.105-.043-.16a3.998 3.998 0 01-.133-.437c-.02-.044-.014-.095-.036-.139-.018-.037-.013-.081-.035-.117-.021-.032-.016-.073-.034-.106-.029-.054-.03-.117-.055-.173-.01-.07-.043-.135-.05-.205-.008-.03-.026-.06-.024-.092.004-.047-.038-.08-.035-.127.002-.034-.034-.054-.038-.087-.008-.054-.039-.102-.047-.156-.007-.046-.03-.087-.035-.134-.006-.045-.033-.084-.032-.13.003-.039-.03-.067-.03-.105-.005-.049-.037-.089-.045-.136-.008-.04-.03-.076-.038-.117-.01-.055-.046-.105-.028-.163a.271.271 0 01.118-.015c.082.004.16-.02.24-.025.062-.002.125.003.186-.007.094-.016.19-.02.285-.02.075-.012.151-.02.227-.024.11.004.219-.03.33-.026.107.004.21-.03.317-.028zm-1.393.255c-.029.005-.069.001-.08.035.075-.021.153-.022.23-.033.115.003.229-.019.343-.03-.165-.004-.328.023-.493.028zm2.02.957c.04.134.059.277.116.407-.014-.088-.039-.173-.056-.26-.024-.048-.038-.1-.06-.147zM5.75 4.887c.028.122.046.249.096.364-.021-.123-.043-.25-.096-.364zm.193.657c.014.095.038.188.058.281.025.055.039.114.06.17a1.758 1.758 0 01-.053-.235c-.006-.048-.03-.092-.035-.141 0-.028-.017-.05-.03-.075zm.405 1.417c.02.061.019.127.04.188.012.037.008.078.025.115.024.045.023.099.052.142-.042-.147-.053-.304-.117-.445zm2.092.37c.004.03.003.06.002.09-.072.03-.149.037-.223.056.065.006.124-.027.189-.024.025.002.044-.017.065-.027-.003-.034-.022-.063-.033-.095zM.086 1.555c.02-.033.03-.075.065-.095.012.068.032.134.046.202.06.194.11.39.16.588.04.126.065.256.11.38.003.04.012.08.026.117.056.199.097.402.162.598.054.2.1.401.161.6.073.287.152.573.229.86.044.156.078.315.124.47.035.124.073.247.1.373l.142.515c.026.129.068.254.1.382.059.22.118.442.174.663.038.139.082.277.115.417.06.242.134.48.192.724.115.41.216.824.334 1.234.071.296.16.588.233.883.047.17.088.34.138.51.009.023.021.045.03.068-.008.043-.054.063-.073.1-.027.051-.077.083-.112.128-.025-.04-.057-.08-.06-.129-.012-.086-.048-.166-.064-.25a107.22 107.22 0 00-.314-1.18c-.07-.272-.14-.543-.216-.813a23.512 23.512 0 00-.19-.723c-.046-.191-.1-.381-.152-.571-.096-.384-.207-.764-.298-1.148-.034-.106-.045-.218-.082-.324-.053-.192-.115-.382-.158-.577a86.22 86.22 0 01-.25-.936c-.04-.187-.1-.37-.147-.556-.1-.394-.208-.787-.31-1.182-.064-.212-.106-.429-.165-.642-.05-.143-.075-.294-.114-.44-.009-.027-.028-.052-.02-.08a.965.965 0 01.084-.166zM1.072 2.485c.064.004.125-.019.188-.026a.07.07 0 01.046.068c-.045.024-.095.01-.143.02-.119.035-.244.023-.365.049-.066.013-.135.013-.202.016-.024 0-.034.03-.024.05.057.002.112-.016.17-.015a.408.408 0 00.126-.017c.047-.016.098-.002.145-.018.055-.002.11-.001.16-.022.046-.006.103-.022.141.01.042.116.067.236.102.353.033.145.076.287.114.431.03.095.048.193.08.287.002.02.002.042 0 .063a.351.351 0 01-.185.03c-.063.014-.126.027-.19.035-.043 0-.087-.001-.127.015-.044.018-.092.007-.137.015-.04.009-.078.025-.118.022-.02-.112-.06-.22-.084-.331-.07-.29-.164-.574-.227-.866-.017-.03-.037-.06-.05-.092a.144.144 0 01.097-.026c.053.006.102-.014.154-.02.063-.014.128.005.19-.014a.42.42 0 01.139-.017zM7.2 2.734c.02-.006.035.067.002.053a.064.064 0 01-.003-.053zM1.477 3.802c.052-.002.103-.015.155-.017.023.031.03.067.013.103-.176-.007-.348.043-.523.05-.082.01-.167.043-.249.013l.003-.06c.035 0 .069-.006.102-.015.047-.014.096-.013.144-.02.06-.007.117-.028.178-.028.06 0 .117-.025.177-.026zM1.214 3.98c.109-.006.218-.012.326-.03a.914.914 0 01.13-.012c.03.06.04.126.061.19.086.32.173.64.262.961l-.394.09c-.054.004-.105.029-.16.03-.068.014-.135.04-.206.037-.097-.355-.194-.71-.288-1.067-.008-.055-.037-.106-.036-.163.043-.023.094-.009.142-.015.054-.009.109-.01.163-.022zM1.826 5.182c.058-.029.125-.028.187-.042a.957.957 0 01.019.065c-.04.019-.085.007-.124.023-.065.025-.136.011-.2.038-.059.025-.126.003-.183.033-.053.024-.116-.008-.166.023-.028.018-.062.011-.093.014a.343.343 0 00.002-.04c.04-.002.083 0 .118-.021.053-.032.119-.015.172-.044.038-.019.084.002.122-.017.045-.026.098-.017.146-.032zM1.7 5.314c.09-.026.184-.021.272-.049.023-.005.051-.016.067.007.062.22.12.442.177.663.035.122.072.244.103.368.027.089.04.182.075.268.006.02-.004.039-.01.057a.23.23 0 00-.101.012c-.045.017-.094.018-.14.03-.057.02-.118.018-.173.041-.07.008-.135.036-.204.046-.041.013-.083.028-.128.022-.002-.04-.014-.077-.027-.114-.098-.357-.19-.716-.289-1.073-.01-.073-.05-.14-.04-.216.055-.001.104-.031.16-.03a.285.285 0 00.099-.017c.05-.021.108.001.16-.015zM2.287 6.693a.29.29 0 01.129-.027l.033.03-.022.03c-.071-.009-.13.044-.203.037-.041-.005-.075.027-.116.028-.034.003-.072-.006-.103.013-.05.032-.113-.004-.164.026-.038.022-.084.012-.126.01a2.294 2.294 0 01-.037.042l.104.002c.052.002.098-.032.15-.026.058.006.109-.032.166-.027.028 0 .057.003.082-.012.049-.025.106-.005.156-.023a.281.281 0 01.11-.02c.081.279.146.562.228.84l.095.368c-.021 0-.042-.002-.062 0-.229.063-.458.128-.689.18-.12-.378-.2-.768-.314-1.149-.014-.057-.035-.114-.036-.174.052-.006.097-.04.15-.035.044.007.071-.042.115-.038a.15.15 0 00.09-.021c.04-.027.093-.004.134-.03.04-.024.089-.004.13-.024zM1.344 7.08c.08.298.156.596.235.894.007.049.033.094.033.144-.026-.088-.063-.172-.091-.259a6.755 6.755 0 01-.16-.607c-.01-.057-.028-.113-.017-.171zM2.657 8.05c.05-.004.098-.052.145-.014v.059c-.056.009-.11.031-.168.029a.384.384 0 01-.15.028.258.258 0 01-.132.023c-.043.015-.093.043-.132.004a.134.134 0 01.057-.023c.04-.008.073-.034.114-.036.04-.003.073-.027.113-.032.052-.006.1-.031.153-.038zM2.706 8.15c.035.005.063-.018.097-.021.01.024.023.048.032.073.082.346.189.686.273 1.032-.017.008-.033.017-.05.023-.232.06-.461.134-.696.185-.038-.1-.055-.205-.089-.306-.036-.128-.065-.257-.102-.384-.039-.155-.093-.307-.12-.464.08.003.155-.038.236-.042.042-.015.082-.04.128-.035.044.001.08-.033.126-.029.058.002.108-.035.165-.031zM2.954 9.338c.054-.027.115-.028.17-.051l.032.047c-.005.02-.017.04-.012.061.045.104.063.216.097.324.057.244.137.482.196.726.033.148.086.291.117.44-.059.027-.127.016-.184.047-.068.01-.138.012-.202.04-.05.005-.098.015-.147.027-.087-.002-.169.04-.256.037 0-.043.003-.088-.015-.128-.033-.129-.072-.256-.107-.385-.078-.315-.169-.627-.25-.94.04-.017.075-.05.121-.05.05.002.091-.037.142-.03.046.006.082-.03.128-.025.052.003.1-.021.15-.034a.601.601 0 00.207-.047c-.034-.038-.096-.024-.139-.01-.043.025-.095.006-.138.03-.048.022-.105.011-.154.032-.042.02-.094-.01-.13.021-.026.018-.058.007-.086.01l.005-.027c.036-.004.077.008.106-.019.028-.025.066-.017.1-.021a.211.211 0 01.124-.035c.038-.023.083-.027.125-.04zM9.74 9.76c.084-.006.162-.049.248-.04.008.04-.012.077-.022.116-.011.033-.023.068-.05.092-.041.024-.092.008-.134.028-.045.021-.096.007-.142.026-.034.013-.07.017-.105.023-.056.006-.108.03-.164.034-.055.006-.106.03-.161.033-.053.003-.102.028-.156.03-.064.004-.124.03-.188.033-.048.002-.092.024-.139.027-.065.005-.125.033-.19.036-.042.001-.08.025-.122.027-.066.004-.127.034-.194.037-.057.003-.11.03-.167.031-.064.003-.124.034-.189.032-.036-.003-.068.018-.103.024-.03.002-.06-.003-.087.01-.054.023-.115.019-.17.035-.066.019-.136.02-.2.042-.08.008-.157.037-.237.042-.043.007-.084.025-.128.026-.061.002-.116.034-.177.036-.04.001-.076.021-.116.025-.064.006-.127.025-.19.037-.076.009-.15.035-.226.042a1.257 1.257 0 01-.263.038c-.288.06-.578.113-.867.172-.055.003-.107.028-.163.029-.179.034-.357.074-.536.108-.055.019-.114.015-.17.034-.188.031-.375.074-.562.11-.29.058-.58.112-.869.169-.052.025-.11.023-.166.037a.159.159 0 01-.077-.002c-.001-.035.024-.059.047-.08.061-.053.112-.119.184-.159.045-.028.101-.024.15-.04a.456.456 0 01.132-.02c.039-.009.076-.027.117-.025.048.002.09-.029.138-.028.066-.002.125-.04.192-.036a.34.34 0 00.152-.04l.051.033c.028-.033.068-.058.113-.056.05.006.092-.023.14-.025.076-.002.146-.041.222-.042.078-.028.162-.028.24-.053.042-.011.087-.007.128-.022.065-.022.135-.017.2-.04.041-.012.084-.006.125-.017.079-.023.161-.027.24-.05.063-.004.121-.03.184-.036.07-.008.139-.034.21-.037.082-.026.168-.024.25-.046.049-.012.1-.008.147-.027.041-.017.088-.005.129-.023.057-.023.121-.016.178-.04.033-.013.07-.013.104-.019.052-.007.1-.032.152-.03.048.002.091-.028.14-.027a.35.35 0 00.095-.016c.06-.02.124-.011.183-.034.04-.015.084-.01.125-.024.061-.018.126-.022.187-.04.063-.018.129-.018.19-.04.043-.014.09-.003.131-.02.049-.018.101-.014.151-.026.043-.01.084-.023.128-.026.047-.001.09-.025.137-.027.062-.004.12-.03.181-.036.048 0 .091-.025.139-.027.073-.004.142-.037.215-.038.048-.003.091-.029.14-.026.053.004.1-.027.151-.027a.386.386 0 00.104-.02c.05-.02.106-.008.154-.034.067-.014.136-.02.201-.042.078 0 .149-.036.226-.04.052.002.1-.031.152-.025.046.007.083-.024.127-.027zM8.833 10.18a.366.366 0 01.145-.016c-.055.041-.126.045-.19.064-.125.026-.254.04-.379.07-.072.02-.143.041-.217.053-.054.005-.11.004-.164.001.002-.033.04-.02.062-.027.066 0 .124-.036.19-.036.065-.018.132-.032.2-.042.069-.024.144-.022.214-.046.045-.015.095-.004.14-.022z" fill="#DEDDD3"/></svg>
                                <span>{{ getEffectInfo(effects, floor.nEffectID, "reward") }}</span>
                            </div>
                        </div>
                    </div>
                    <i class="u-info-icon el-icon-arrow-up"></i>
                    <i class="u-info-icon el-icon-arrow-down"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { __imgPath } from "@jx3box/jx3box-common/data/jx3box.json";
import { arr1to2, isPhone, isQQ, isWeChat, getEffectInfo } from "../utils";
import { cloneDeep } from "lodash";
import html2canvas from "html2canvas";
import { moment } from "@jx3box/jx3box-common/js/moment";
export default {
    name: "MapCompleted",
    props: ["effectsFilter", "updatedAt"],
    data() {
        return {
            loading: false,
        };
    },
    computed: {
        __imgRoot() {
            return __imgPath + "pve/baizhan/";
        },
        list() {
            const data = cloneDeep(this.$attrs.maps);
            return arr1to2(data, this.$attrs.column);
        },
        currentBoss() {
            return this.$attrs.currentBoss || {};
        },
        currentEffectIds() {
            return this.$attrs.currentEffect?.ids || [];
        },
        currentBossName() {
            return this.$attrs.currentBossName || "";
        },
        effects() {
            return this.$attrs.effects || [];
        },
        mapFilterInit() {
            return this.$attrs.mapFilterInit || "init";
        },
        update_moment() {
            return moment(this.updatedAtt);
        },
        duration() {
            return {
                start: this.update_moment.startOf("week").format("MM/DD"),
                end: this.update_moment.endOf("week").format("MM/DD"),
            };
        },
    },
    methods: {
        getCurrentStyle(floor, index) {
            const indexes = [10, 20, 30, 40, 50, 60];
            if (this.mapFilterInit === "init") {
                return indexes.includes(index) || this.effectsFilter[0].ids.includes(floor.nEffectID)
                    ? "is-current"
                    : "";
            } else {
                if (this.currentBossName && this.currentEffectIds.length) {
                    return (this.currentBossName === "精英首领"
                        ? indexes.includes(index)
                        : this.currentBossName === floor.bossName) && this.currentEffectIds.includes(floor.nEffectID)
                        ? "is-current"
                        : "";
                }
                return (
                    (!this.currentBossName && this.currentEffectIds.includes(floor.nEffectID) ? "is-current" : "") ||
                    (!this.currentEffectIds.length &&
                    (this.currentBossName === "精英首领"
                        ? indexes.includes(index)
                        : this.currentBossName === floor.bossName)
                        ? "is-current"
                        : "")
                );
            }
        },
        isPhone,
        getBossAvatar(id) {
            const avatar =
                this.$attrs.bosses.find((item) => item.id === id)?.avatar || `${this.__imgRoot}fbcdpanel02_51.png`;
            return avatar;
        },
        getEffectInfo,
        setBossHandler(i) {
            if (i === this.initQuery.index) {
                this.$store.commit("baizhan/setState", {
                    key: "currentBoss",
                    val: {},
                });
                return this.$router.push({ query: {} });
            }
            this.$router.push({ query: { floor: i } });
        },
        setBoss(floor, i) {
            console.log(floor, i);
            // let val = floor;
            // if (floor.dwBossID === this.currentBoss?.dwBossID) {
            //     console.log(123);
            //     val = {};
            // } else {
            //     val = Object.assign(floor, {
            //         floor: i,
            //     });
            // }
            // // this.$store.dispatch("baizhan/setInit", val);
            // this.$store.commit("baizhan/setState", {
            //     key: "currentBoss",
            //     val,
            // });
        },
        exportToImage() {
            if (isPhone() && (isWeChat() || isQQ())) {
                return this.$message({
                    message: "请在游览器中打开",
                    type: "warning",
                });
            }
            const map = this.$refs.map;
            this.loading = true;
            html2canvas(map, {
                useCORS: true,
                width: map.offsetWidth,
                height: map.offsetHeight,
                scale: 2,
            })
                .then((canvas) => {
                    this.createWatermark().then((waterCanvas) => {
                        const newCanvas = document.createElement("canvas");
                        const newCtx = newCanvas.getContext("2d");
                        newCanvas.width = map.offsetWidth * 2;
                        newCanvas.height = map.offsetHeight * 2;
                        newCtx.drawImage(canvas, 0, 0);
                        newCtx.drawImage(waterCanvas, 0, 0);
                        // this.canvas = newCanvas.toDataURL();
                        // 创建一个虚拟链接
                        const link = document.createElement("a");
                        link.href = newCanvas.toDataURL(); // 将 Canvas 转换为 Data URL
                        link.download = `魔盒百战${this.duration.start}至${this.duration.end}.png`; // 下载文件的名称

                        link.addEventListener("click", () => {
                            setTimeout(() => {
                                URL.revokeObjectURL(link.href); // 删除链接的资源
                            }, 100); // 延迟删除以确保下载完成

                            link.removeEventListener("click", () => {}); // 移除事件监听器
                            document.body.removeChild(link);
                        });
                        document.body.appendChild(link);
                        link.click();
                        this.loading = false;
                        // this.$store.commit("baizhan/setState", {
                        //     key: "downLoading",
                        //     val: false,
                        // });
                    });
                })
                .catch((error) => {
                    this.loading = false;
                    this.$store.commit("baizhan/setState", {
                        key: "downLoading",
                        val: false,
                    });
                    console.error("导出图片出错:", error);
                });
        },
        createWatermark() {
            return new Promise((resolve) => {
                const map = this.$refs.map;
                const canvas = document.createElement("canvas");
                canvas.width = map.offsetWidth * 2;
                canvas.height = map.offsetHeight * 2;
                const ctx = canvas.getContext("2d");

                // 绘制顶部文字
                ctx.font = `bold 48px Arial`;
                ctx.fillStyle = "#deddd3";
                ctx.textBaseline = "middle";
                ctx.textAlign = "center"; // 设置居中对齐

                const topTxt = `百战异闻录 ${this.duration.start} 至 ${this.duration.end}`;
                const topTxtX = canvas.width / 2; // 居中位置
                const topTxtY = 30 * 1.5; // 垂直位置
                ctx.fillText(topTxt, topTxtX, topTxtY);

                const bottomTxt = "魔盒·百战查询 https://www.jx3box.com/fb/baizhan";
                ctx.font = `bold 30px Arial`;
                const txtBottomWidth = ctx.measureText(bottomTxt).width;
                const bottomTxtX = canvas.width - txtBottomWidth / 2 - 30 * 2;
                const bottomTxtY = canvas.height - topTxtY; // 垂直位置
                ctx.fillText(bottomTxt, bottomTxtX, bottomTxtY);

                // 绘制文字水印
                // const txt = "JX3BOX";
                const txt = "";
                const txtHeight = canvas.height / 6;
                const txtWidth = ctx.measureText(txt).width;
                const txtRepeat = Math.ceil(canvas.width / (txtWidth + 20)) * 2; // 添加间隔距离
                const txtRows = Math.ceil(canvas.height / (txtHeight + 20)) * 2; // 添加间隔距离
                ctx.font = `bold 12px Arial`;
                ctx.fillStyle = "#deddd31a";
                ctx.transform(1, 0.5, -0.5, 1, 0, -canvas.height / 2);
                for (let i = 0; i < txtRows; i++) {
                    for (let j = 0; j < txtRepeat; j++) {
                        const x = j * (txtWidth + 20); // 添加间隔距离
                        const y = i * (txtHeight + 20); // 添加间隔距离
                        ctx.fillText(txt, x, y);
                    }
                }

                // 加载本地图片
                const image = new Image();
                image.src = require("@/assets/img/logo.svg");
                image.crossOrigin = "";
                image.onload = () => {
                    // 创建临时canvas用于处理图片
                    const imageSize = 30 * 2;
                    const tempCanvas = document.createElement("canvas");
                    tempCanvas.width = imageSize;
                    tempCanvas.height = imageSize;
                    const tempCtx = tempCanvas.getContext("2d");
                    tempCtx.drawImage(image, 0, 0, imageSize, imageSize);

                    // 获取图片的ImageData对象
                    const imageData = tempCtx.getImageData(0, 0, imageSize, imageSize);

                    // 修改图片颜色
                    const pixels = imageData.data;
                    for (let i = 0; i < pixels.length; i += 4) {
                        // 修改RGBA颜色值
                        pixels[i] = 255 - pixels[i]; // R
                        pixels[i + 1] = 255 - pixels[i + 1]; // G
                        pixels[i + 2] = 255 - pixels[i + 2]; // B
                    }

                    // 将修改后的ImageData对象绘制到canvas中
                    const textWidth = ctx.measureText(topTxt).width * 2; // 顶部文字的宽度
                    const padding = 10; // 图片与文字之间的间距
                    const imageX = topTxtX - textWidth - imageSize - padding;
                    ctx.putImageData(imageData, imageX, 15);

                    resolve(canvas);
                };
            });
        },
    },
};
</script>

<style lang="less">
@import "../assets/css/var.less";
.m-completed-map {
    .flex;
    justify-content: center;
    align-items: flex-start;
    overflow: hidden;
    width: 100%;
    height: 100%;
    margin-top: -25px;
    .u-phone-download {
        .none;
    }
    @media screen and (max-width: @phone) {
        flex-direction: column;
        align-items: center;
        .u-phone-download {
            position: absolute;
            top: 0;
            .db;
            width: 80%;
        }
    }
    .m-boss-list {
        position: relative;
        box-sizing: border-box;
        .flex;
        flex-direction: column;
        box-sizing: border-box;
        transition: transform 0.2s ease-out;
        cursor: grab;
        background-color: @baizhan_bg;
        user-select: none;
        padding: 30px;
        .u-watermark {
            display: none;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            .u-title {
                .flex;
                justify-content: center;
                align-items: center;
                gap: 10px;
                color: @baizhan_map_select_color;
                margin: 0;
                padding-top: 5px;
                font-size: 18px;
                svg {
                    width: 30px;
                    height: 30px;
                }
            }
            .u-bottom-title {
                position: absolute;
                bottom: 10px;
                width: 100%;
                text-align: center;
            }
            .u-watermark-content {
                position: absolute;
                top: 10%;
                left: 10%;
                width: 90%;
                height: 80%;
                box-sizing: border-box;
                z-index: 0;
                overflow: hidden;
                .flex;
                flex-wrap: wrap;
                gap: 100px;
                .u-title {
                    opacity: 0.1;
                    color: @baizhan_map_select_color;
                    transform: rotate(30deg);
                }
            }
        }
        .u-download {
            position: absolute;
            right: -30px;
            top: 55px;
            display: none;
            z-index: 2;
        }
        &:hover {
            .u-download {
                display: block;
            }
        }
        .u-floor {
            position: relative;
            flex: none;
            width: 100px;
            height: 100px;
            border-radius: 10px;
            background: @baizhan_map_bg;
            .flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            z-index: 2;
            transition: height 0.2s ease-out;
            color: @baizhan_map_color;
            .u-floor-content {
                .flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                gap: 4px;
                width: 100%;
                height: 100%;
            }
            .u-info-icon {
                .none;
                position: absolute;
                transform: rotate(134deg);
                color: @baizhan_active;
                font-weight: bold;
            }
            .el-icon-arrow-down {
                top: -10px;
                left: -10px;
            }
            .el-icon-arrow-up {
                bottom: -10px;
                right: -10px;
            }
            .u-img {
                width: 40px;
                height: 40px;
                border-radius: 50%;
                user-select: none;
                img {
                    user-select: none;
                }
            }
            .u-index {
                position: absolute;
                left: 4px;
                top: 4px;
                font-size: 12px;
                color: #fff;
                font-weight: bold;
                color: @baizhan_active;
            }
            .u-name {
                color: @baizhan_active;
                font-size: 14px;
                font-weight: bold;
                width: 80px;
                text-align: center;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            .u-desc {
                .size(80px, 52px);
                .flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                color: @baizhan_active;
                .u-coin {
                    .flex;
                    justify-content: center;
                    align-items: center;
                    gap: 2px;
                }
            }
            .u-icon {
                position: absolute;
                bottom: 4px;
                right: 4px;
                width: 15px;
                height: 15px;
                border-radius: 50%;
                overflow: hidden;
                display: flex;
                align-items: center;
                justify-content: center;
                img {
                    .size(100%, 100%);
                    border-radius: 50%;
                    transform: scale(1.2);
                    user-select: none;
                }
            }
            &::after {
                position: absolute;
                right: -8px;
                width: 8px;
                height: 4px;
                display: block;
                background-color: @baizhan_map_bg;
                content: "";
            }
            &.is-effect {
                // background-color: @baizhan_active;
                // color: @baizhan_map_select_color;
                .u-floor-content {
                    justify-content: flex-start;
                }
                .u-img {
                    position: absolute;
                    top: -20px;
                    border: 2px solid @baizhan_map_bg;
                    box-sizing: border-box;
                    user-select: none;
                }
                .u-name {
                    margin-top: 20px;
                    font-size: 16px;
                }
                .u-desc {
                    font-size: 12px;
                    text-align: center;
                    .u-coin-img {
                        filter: invert(50%) sepia(74%) saturate(353%) hue-rotate(201deg) brightness(86%) contrast(92%);
                    }
                }
            }
            &.is-gray {
                // opacity: 0.3;
                background-color: @baizhan_map_bg;
                color: @baizhan_map_color;
            }
            &.is-current {
                // height: 110px;
                // opacity: 1;
                background-color: @baizhan_active !important;
                color: @baizhan_map_select_color !important;
                .u-name,
                .u-index {
                    color: @baizhan_map_select_color;
                }
                &.is-effect {
                    .u-img {
                        border-color: @baizhan_active;
                    }
                    .u-desc {
                        color: @baizhan_map_select_color;
                        .u-coin-img {
                            filter: none;
                        }
                    }
                }
            }
            &.is-info {
                background-color: @baizhan_active !important;
                color: @baizhan_map_select_color !important;
                .u-name,
                .u-index {
                    color: @baizhan_map_select_color;
                }
                .u-img {
                    border-color: @baizhan_active;
                }
                .u-desc {
                    color: @baizhan_map_select_color;
                    .u-coin-img {
                        filter: none;
                    }
                }
                .u-info-icon {
                    .db;
                }
            }
            &:nth-of-type(10n),
            &:nth-of-type(10n).is-effect {
                height: 150px;
                // background-color: @baizhan_active;
                // &.is-current {
                //     height: 160px !important;
                // }
                .u-floor-content {
                    justify-content: center;
                }
                .u-name {
                    margin-top: 0;
                }
                .u-img {
                    position: relative !important;
                    top: unset !important;
                    box-sizing: border-box;
                    border: 4px solid @baizhan_map_select_color;
                    width: 50px;
                    height: 50px;
                    user-select: none;
                }
                &::after {
                    right: unset;
                    bottom: -25px;
                    width: 4px;
                    height: 25px;
                }
            }
        }
        .u-step {
            .flex;
            justify-content: center;
            align-items: center;
            gap: 8px;
            height: 150px;
            color: @baizhan_map_color;
            &.has-info {
                .u-floor {
                    opacity: 0.2;
                    &.is-info {
                        opacity: 1;
                    }
                }
            }
            &:nth-of-type(even) {
                flex-direction: row-reverse;
                .u-floor {
                    &::after {
                        position: absolute;
                        right: unset;
                        left: -8px;
                        width: 8px;
                        height: 4px;
                        display: block;
                        background-color: @baizhan_map_bg;
                        content: "";
                    }
                    &:nth-of-type(10n),
                    &:nth-of-type(10n).is-effect {
                        height: 150px;
                        // background-color: @baizhan_active;
                        .u-floor-content {
                            justify-content: center;
                        }
                        .u-name {
                            margin-top: 0;
                        }
                        .u-img {
                            position: relative !important;
                            top: unset !important;
                            box-sizing: border-box;
                            border: 4px solid @baizhan_map_select_color;
                            width: 50px;
                            height: 50px;
                        }
                        &::after {
                            left: unset;
                            bottom: -25px;
                            width: 4px;
                            height: 25px;
                        }
                    }
                }
            }
            &:nth-of-type(6) {
                .u-floor {
                    &:last-of-type {
                        &::after {
                            display: none;
                        }
                    }
                }
            }
        }
    }

    .m-right {
        flex: none;
        padding: 40px 100px 40px 40px;
        border-radius: 10px;
        background-image: url("@{baizhan_img_path}baizhan2_4.png");
        background-repeat: no-repeat;
        background-size: cover;
        color: #fff;
        box-sizing: border-box;
        .m-header {
            .flex;
            align-items: center;
            gap: 10px;
        }
        .u-title {
            background-image: url("@{baizhan_img_path}baizhan_31.png");
            width: 26px;
            height: 71px;
            line-height: 71px;
            text-align: center;
            font-style: italic;
        }
        .u-boss-name {
            writing-mode: vertical-lr;
        }
    }
    .m-show-wrap {
        max-width: 500px;
        .m-header {
            gap: 20px;
        }
        .u-avatar {
            margin-left: -12px;
            margin-right: -12px;
            width: 120px;
            height: 120px;
            background-image: url("@{baizhan_img_path}baizhan_39.png");
            background-repeat: no-repeat;
            background-size: cover;
            .flex;
            justify-content: center;
            align-items: center;
            img {
                width: 90px;
                height: 90px;
                border-radius: 50%;
            }
        }
        .u-effect-icon {
            .size(48px, 48px);
        }
        .u-effect-info {
            .flex;
            flex-direction: column;
            .u-effect-name {
                font-weight: bold;
            }
            .u-effect-desc {
                font-size: 12px;
                max-width: 200px;
                color: @skill_2;
            }
        }
        .m-reward {
            margin-top: 20px;
            .flex;
            gap: 20px;
            .u-title {
                background-image: url("@{baizhan_img_path}baizhan_32.png");
            }
            .u-rewards {
                .flex;
                align-items: center;
                gap: 10px;
            }
        }
    }
    .m-edit-wrap {
        .flex;
        gap: 20px;
        .m-form {
            .flex;
            flex-direction: column;
            gap: 10px;
        }
    }
}

.u-effect-option {
    .flex;
    align-items: center;
    gap: 10px;
    img {
        width: 20px;
        height: 20px;
    }
}
</style>
